import {Container, Stack, Typography} from "@mui/material";
import React from "react";
import Box from "@mui/material/Box";
import {useTheme} from '@mui/material/styles';
import {BminingSaaSHomeMainBannerComponent} from "./BminingSaaSHomeMainBannerComponent";
import {BminingSaaSHomeCavingPlanningComponent} from "./BminingSaaSHomeCavingPlanningComponent";
import {useIsDesktop} from "../../hooks/useIsDesktop";
import {BminingSaasHomeProductsComponent} from "./BminingSaasHomeProductsComponent";
import {BminingSaaSHomeWhyComponent} from "./BminingSaaSHomeWhyComponent";
import {BminingSaaSHomeWorkflowComponent} from "./BminingSaaSHomeWorkflowComponent";
import {
    CavingPlanningDesktopComponent,
    CavingPlanningAccordionComponent,
    BminingSaaSCavingPlanningComponent
} from "./BminingSaasCaving/BminingSaaSCavingComponent";
import {spacing} from "../../Resources/styles";

export const BminingSaasHomeComponent = () => {
    const isDesktop = useIsDesktop()

    return <Container>
        <Stack spacing={spacing}>
            <Box>
                <BminingSaaSHomeMainBannerComponent/>
            </Box>


            <Box sx={{backgroundColor: isDesktop ? "#fafafa" : "default"}}>
                <BminingSaasHomeProductsComponent/>
            </Box>

            <Box>
                {isDesktop && <CavingPlanningDesktopComponent/>}
                {!isDesktop && <CavingPlanningAccordionComponent/>}
            </Box>

            <Box sx={{backgroundColor: isDesktop ? "#fafafa" : "default"}}>
                <BminingSaaSHomeWhyComponent/>
            </Box>

            {/*<Box>*/}
            {/*    <Typography>Como funciona</Typography>*/}
            {/*</Box>*/}

            {/*<Box sx={{backgroundColor: theme.palette.secondary.main}}>*/}
            {/*    <Typography>Power BI Embebido</Typography>*/}
            {/*</Box>*/}

            {/*<Box>*/}
            {/*    <Typography>Hablemos</Typography>*/}
            {/*    <BminingSaaSHomeWorkflowComponent/>*/}
            {/*</Box>*/}

            {/*<Box>*/}
            {/*    <Typography>Colocar El Concepto de Power BI</Typography>*/}
            {/*</Box>*/}
        </Stack>
    </Container>
}

